import { render, staticRenderFns } from "./TaskFields.vue?vue&type=template&id=62c1a2cb&"
import script from "./TaskFields.vue?vue&type=script&lang=js&"
export * from "./TaskFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/cabcom.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62c1a2cb')) {
      api.createRecord('62c1a2cb', component.options)
    } else {
      api.reload('62c1a2cb', component.options)
    }
    module.hot.accept("./TaskFields.vue?vue&type=template&id=62c1a2cb&", function () {
      api.rerender('62c1a2cb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/deliverables/TaskFields.vue"
export default component.exports